/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useState} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, setLanguage} from '../../../i18n/Metronici18n'
import {createLocale} from '../../../../app/modules/profile/core/_requests'
import {useAuth} from '../../../../app/modules/auth'
import {getLocaleData} from '../core/_requests'
import '../style/languages.scss'
const languages = [
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    value: 'en_US',
  },
  {
    lang: 'zh',
    name: 'Mandarin-普通話',
    flag: toAbsoluteUrl('/media/flags/china.svg'),
    value: 'zh_CN',
  },
  {
    lang: 'es',
    name: 'Spanish-Español',
    flag: toAbsoluteUrl('/media/flags/spain.svg'),
    value: 'es_ES',
  },
  {
    lang: 'ja',
    name: 'Japanese-日本',
    flag: toAbsoluteUrl('/media/flags/japan.svg'),
    value: 'ja_JP',
  },
  {
    lang: 'de',
    name: 'German-Deutsch',
    flag: toAbsoluteUrl('/media/flags/germany.svg'),
    value: 'de_GN',
  },
  {
    lang: 'fr',
    name: 'French-Français',
    flag: toAbsoluteUrl('/media/flags/france.svg'),
    value: 'fr_FR',
  },
  {
    lang: 'hi',
    name: 'Hindi-हिंदी',
    flag: toAbsoluteUrl('/media/flags/india.svg'),
    value: 'hi_HI',
  },
  {
    lang: 'bn',
    name: 'Bangla-বাংলা',
    flag: toAbsoluteUrl('/media/flags/bangladesh.svg'),
    value: 'bn_BN',
  },
  {
    lang: 'it',
    name: 'Italian-italiano',
    flag: toAbsoluteUrl('/media/flags/italy.svg'),
    value: 'it_IT',
  },
  {
    lang: 'ko',
    name: 'Korean-한국인',
    flag: toAbsoluteUrl('/media/flags/south-korea.svg'),
    value: 'ko_KO',
  },
  {
    lang: 'pt',
    name: 'Portuguese-Português',
    flag: toAbsoluteUrl('/media/flags/portugal.svg'),
    value: 'pt_PT',
  },
  {
    lang: 'ru',
    name: 'Russian-Русский',
    flag: toAbsoluteUrl('/media/flags/russia.svg'),
    value: 'ru_RU',
  },
]

const Languages: FC = () => {
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)
  const {currentUser} = useAuth()
  const [status, setStatus] = useState(true)
  const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'
  const handleLanguage = async (value: string) => {
    try {
      const {
        data: {success},
      } = await createLocale('locale', value, currentUser?.company[0].companyId)
      if (success) {
        await Locale()
      }
    } catch (e) {
      console.log(e)
    }
  }

  const Locale = async () => {
    try {
      const {
        data: {data, success},
      } = await getLocaleData()
      if (success) {
        data.forEach((e: any) => {
          if (e.key === 'locale') {
            if (e.value === 'fr_FR') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'fr'}))
              }
            } else if (e.value === 'de_GN') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'de'}))
              }
            } else if (e.value === 'ja_JP') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'ja'}))
              }
            } else if (e.value === 'es_ES') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'es'}))
              }
            } else if (e.value === 'zh_CN') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'zh'}))
              }
            } else if (e.value === 'hi_HI') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'hi'}))
              }
            } else if (e.value === 'bn_BN') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'bn'}))
              }
            } else if (e.value === 'it_IT') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'it'}))
              }
            } else if (e.value === 'ko_KO') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'ko'}))
              }
            } else if (e.value === 'pt_PT') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'pt'}))
              }
            } else if (e.value === 'ru_RU') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'ru'}))
              }
            } else {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'en'}))
              }
            }
          } else if (e.key === 'dateFormat') {
            localStorage.setItem('dateFormat', e.value)
          } else if (e.key === 'timeFormat') {
            localStorage.setItem('timeFormat', e.value)
          } else if (e.key === 'timezone') {
            localStorage.setItem('timeZone', e.value)
          }
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
  return (
    <div
      className='menu-item px-5 my-1'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      <a href='#' className='menu-link px-5'>
        <span className='menu-title position-relative'>
          Language
          <span className='fs-7 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
            {currentLanguage?.name}{' '}
            <img
              className='w-15px h-15px rounded-1 ms-2'
              src={currentLanguage?.flag}
              alt='metronic'
            />
          </span>
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown sub-menu-positioner2 py-4'>
        {languages.map((l) => (
          <div
            className='menu-item px-3'
            key={l.lang}
            onClick={() => {
              setLanguage(l.lang)
              handleLanguage(l.value)
            }}
          >
            <a
              href='#'
              className={clsx('menu-link d-flex px-5', {active: l.lang === currentLanguage?.lang})}
            >
              <span className='symbol symbol-20px me-4'>
                <img className='rounded-1' src={l.flag} alt='metronic' />
              </span>
              {l.name}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Languages}
